import React from 'react';
import {useLocation, useParams} from 'react-router-dom';
import getStoreRecordsByMask from '../../utilities/get-store-records-by-mask';
import {graphql, useMutation} from 'react-relay/hooks';
import {RouterLinkButton} from '../../components/button/button';
import searchFilter from '../../searchFilter';

const ShareAccess = () => {
    const {contractId} = useParams();
    const location = useLocation();
    const [status, setStatus] =  React.useState('pending');
    const [errorType, setErrorType] =  React.useState();
    const [acceptContract, acceptingContract] = useMutation(
        graphql`
            mutation shareAccessPagesAcceptWithMyselfMutation($request: AcceptWithMyselfRequestInput) {
                acceptWithMyself(request: $request) {
                    client {
                        id
                    }
                    clientEmail
                    id
                    merchant {
                        id
                    }
                    note
                    role
                    status
                    version
                }
            }
    `);
    const accept = () => {
        acceptContract({
            variables: {request: {
                id: contractId,
            }},
            onCompleted: (data) => {
                setStatus(data.acceptWithMyself.status === 1 ? 'success' : 'error')
            },
            onError: (err) => {
                setStatus('error');
                if (err.toString().includes('Contract invalid')) {
                    setErrorType('contract');
                }
                if (err.toString().includes('User invalid')) {
                    setErrorType('user');
                }
            },
            updater: store => {
                const recordIds = getStoreRecordsByMask(store, 'contractsByClient');
                if (recordIds.length) {
                    recordIds.forEach(id => {
                        store.get(id).invalidateRecord();
                    })
                }
            }
        });
    };
    React.useEffect(() => {
        accept();
    }, []);
    return (
        <div className='pages'>
            <div className='share-access'>
                <div className='view'>
                    <div className='padding-top-2rem display-flex flex-direction-column align-items-center'>
                        <p className='text-md color-gray-900 padding-bottom-1rem'>Share access status: {status}</p>
                        {status === 'error' && <p className='text-md color-gray-900 padding-bottom-1rem'>Reason: {errorType} invalid</p>}
                        <RouterLinkButton {...{to: `/business${searchFilter(location.search)}`, color: 'primary', size: 'md'}}>
                            To business cabinet
                        </RouterLinkButton>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default React.memo(ShareAccess);